// extracted by mini-css-extract-plugin
export var standaloneTable = "_ig-0";
export var standaloneTableWithBodyFill = "_ig-1";
export var withExtraHeader = "_ig-2";